module.exports = __webpack_public_path__ + "img/star1-new.ca471b29.png";